<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Producer Area Rate"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedProducerAreaRates"
      :columns="columns"
      :total-rows="totalProducerAreaRates"
      :get-edit-url="getEditUrl"
    />
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'ProducerAreaRateTable',
  components: {
    BaseTable
  },
  data() {
    return {
      producerAreaRates: [],
      totalProducerAreaRates: 0,
      producerAreas: [], // For producer area dropdown
      crops: [], // For crop dropdown
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'producer_area_name', align: 'left', label: 'Producer Area', field: 'producer_area_name', sortable: true },
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'crop_name', align: 'left', label: 'Crop', field: 'crop_name', sortable: true },
        { name: 'ton_rate', align: 'right', label: 'Ton Rate', field: 'ton_rate', sortable: true },
        { name: 'mile_rate', align: 'right', label: 'Mile Rate', field: 'mile_rate', sortable: true },
        { name: 'min_miles', align: 'right', label: 'Min Miles', field: 'min_miles', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedProducerAreaRates() {
      return this.producerAreaRates.map(rate => ({
        ...rate,
        producer_area_name: rate.producer_area_id.name, // Assuming the API returns nested producer area object with `name`
        crop_name: rate.crop_id.crop, // Assuming the API returns nested crop object with `crop`
      }));
    }
  },
  created() {
    this.fetchProducerAreaRates();
    this.fetchProducerAreas();
    this.fetchCrops();
  },
  methods: {
    fetchProducerAreaRates() {
      axios
        .get('/api/v1/producer_area_rate/producer-area-rates/')
        .then(response => {
          this.producerAreaRates = response.data;
          this.totalProducerAreaRates = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching producer area rates:', error);
        });
    },
    fetchProducerAreas() {
      axios
        .get('/api/v1/producer_area/producer-areas/')
        .then(response => {
          this.producerAreas = response.data;
        })
        .catch(error => {
          console.error('Error fetching producer areas:', error);
        });
    },
    fetchCrops() {
      axios
        .get('/api/v1/crop/crops/')
        .then(response => {
          this.crops = response.data;
        })
        .catch(error => {
          console.error('Error fetching crops:', error);
        });
    },
    onAdd() {
      this.$router.push('/producer_area_rate/add');
    },
    getEditUrl(row) {
      return `/producer_area_rate/edit/${row.id}/`;
    }
  },
  watch: {
    producerAreaRates() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the ProducerAreaRateTable here */
</style>
